import React from 'react';
import { DevicePolicy as BaseDevicePolicy } from '@chegg/commerce-utils';
import { DevicePolicyWrapper } from '../styled';
import onError from '../../../utils/onError';
var DevicePolicy = function DevicePolicy(_ref) {
  var devicePolicy = _ref.devicePolicy;
  return /*#__PURE__*/React.createElement(DevicePolicyWrapper, null, /*#__PURE__*/React.createElement(BaseDevicePolicy, {
    onError: onError,
    content: devicePolicy
  }));
};
export default DevicePolicy;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/CartCheckout/internals/DevicePolicy.js
// module id = 4359
// module chunks = 11